import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import ServiceCard from './ServiceCard';
import { generateTestId, getMediaPath } from '../../../app/functions';

const ScrollContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  display: 'flex',
  justifyContent: 'flex-start',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  '-ms-overflow-style': 'none',
  'scrollbarWidth': 'none',
  [theme.breakpoints.up('lg')]: {
    padding: '0px 40px',
  }
}));

const CardsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: '24px 24px 60px 24px',
  alignItems: 'center', 
  '& > *': {
    flexShrink: 0,
  },
  [theme.breakpoints.up('sm')]: {
    padding: '28px 32px 60px 32px',
  },
  [theme.breakpoints.up('md')]: {
    gap: '20px',
  },
  [theme.breakpoints.up('lg')]: {
    padding: '28px 40px 60px 30px',
  },
  [theme.breakpoints.up('xl')]: {
    gap: '0px',
    padding: '28px 40px 60px 40px',
  },
}));


const ServicesSection = ({ data, testID }) => {
  if(!data?.services?.length) return null;
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: theme.palette.background.lightBlue,
        display: 'flex',
        flexDirection: 'column',
      }}
      testID={generateTestId(testID, 'root')}
    >
      <Typography
        sx={{
          color: '#1D094C',
          fontSize: { xs: '24px' },
          fontWeight: 700,
          lineHeight: 'normal',
          textAlign: 'center',
          paddingTop: '24px',
          [theme.breakpoints.up('sm')]: {
            paddingTop: '30px',
            fontSize: '32px',
          },
          [theme.breakpoints.up('md')]: {
            fontSize: '36px',
          },
          [theme.breakpoints.up('lg')]: {
            fontSize: '40px',
          },
        }}
        testID={generateTestId(testID, 'title')}
      >
        <Typography variant="sectionTitle">{data.title}</Typography>
      </Typography>

      <ScrollContainer 
       testID={generateTestId(testID, 'scroll-container')}
       sx={{
        justifyContent: 'flex-start',
        [theme.breakpoints.up('lg')]: {
          justifyContent: 'center',
         }
       }}
       
       >
        <CardsContainer testID={generateTestId(testID, 'cards-container')}>
          {data.services.map((service, index) => (
            <ServiceCard
              key={index}
              title={service.title}
              description={service.description}
              icon={getMediaPath(service.imagePath)}
              testID={generateTestId(testID, `service-card-${index}`)}
            />
          ))}
        </CardsContainer>
      </ScrollContainer>
    </Box>
  );
};

export default ServicesSection; 